import { render, staticRenderFns } from "./SandwichPage.vue?vue&type=template&id=85b79728&scoped=true&"
import script from "./SandwichPage.vue?vue&type=script&lang=js&"
export * from "./SandwichPage.vue?vue&type=script&lang=js&"
import style0 from "./SandwichPage.vue?vue&type=style&index=0&id=85b79728&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b79728",
  null
  
)

export default component.exports